// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"DonationRibbon_ribbon__3v3GD","wrapper":"DonationRibbon_wrapper__bWJhf","badge":"DonationRibbon_badge__kF3bF","textWrapper":"DonationRibbon_textWrapper__LYggu"};